import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';
const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    marginRight: theme.spacing.unit,
  },
  section1: {
    margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  section2: {
    margin: theme.spacing.unit * 2,
  },
  section3: {
    margin: `${theme.spacing.unit * 6}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
    maxWidth:'50px',
  },
});

class  SelectWorkpackage extends React.Component  {
  state={}

  constructor(props)
  {
    super(props);
    //bindings
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
  }

  componentDidMount()
  {
    //Consultar los workpackages 
    this.props.actions.fetchWorkpackages(this.props.deliverable)
    .then(res=>{
      if(res.data.workpackages && res.data.workpackages.length>0)
      {
        let workpackages = res.data.workpackages.map(workpackage=>{
          let w = {};
          w.workpackage = w.value =workpackage.workpackage;
          w.name = w.label= workpackage.name;
          return w;
        });
        this.setState({
          workpackages: workpackages, 
          workpackage: workpackages[0].workpackage,
        });
        this.props.changeWorkpackage( workpackages[0].workpackage, workpackages[0].name);
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    this.setState({workpackage:val});
    this.props.changeWorkpackage(val.workpackage, val.name);
  }

  render()
  {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div className={classes.section1}>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="h6">
                Cost Information
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={24}>
            
            <Grid item sm={3}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Work Package</InputLabel>
                <Select
                  required
                  id="workpackage"
                  name="workpackage"
                  value={this.getValueCatalog(this.state.workpackages,this.state.workpackage)}
                  onChange={this.handleChangeSelection}
                  options={this.state.workpackages}
                >
                </Select>
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
}

SelectWorkpackage.propTypes = {
  classes: PropTypes.object.isRequired,
};
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    ca: state.ca,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectWorkpackage));



// WEBPACK FOOTER //
// ./src/features/cost/SelectWorkpackage.js